import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AuthService from "../../services/auth.service";
import { Logo } from "../../assets/img";
import {
  MdOutlineMail,
  MdVpnKey,
  MdArrowForward,
  MdArrowBack,
} from "react-icons/md";

const Recover = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1: Email, 2: Código
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  // Paso 1: Solicitar Código
  const handleRequestCode = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Por favor, ingrese su correo electrónico");
      return;
    }

    setLoading(true);
    try {
      await AuthService.recover({ email });
      toast.success(
        "Se le ha enviado un correo electrónico con un código de recuperación",
      );
      setStep(2);
    } catch (error) {
      toast.error("Error al solicitar recuperación");
    } finally {
      setLoading(false);
    }
  };

  // Paso 2: Verificar Código
  const handleVerifyCode = async (e) => {
    e.preventDefault();
    if (!code) {
      toast.error("Por favor, ingrese el código");
      return;
    }

    setLoading(true);
    try {
      const response = await AuthService.checkCode({ code });
      if (response && response.result === true) {
        navigate(`/recover/${code}`);
      } else {
        toast.error("El código ingresado es incorrecto o ha expirado");
      }
    } catch (error) {
      toast.error("Ocurrió un error al verificar el código");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#F4F4F2] font-sans">
      <div className="w-[88%] max-w-[400px] bg-white px-6 pt-8 pb-10 rounded-3xl shadow-[0_4px_12px_rgba(0,0,0,0.06)] flex flex-col">
        <img
          src={Logo}
          alt="Bórralo Logo"
          className="w-[140px] h-[140px] object-contain self-center mt-2 mb-2 bg-transparent"
        />

        <div className="flex flex-col items-center mb-6 text-center">
          <h1 className="text-[#1D3B8B] font-black text-[20px] tracking-wide m-0">
            {step === 1 ? "RECUPERAR" : "VERIFICAR"}
          </h1>
          <p className="text-[#6B7280] text-[14px] mt-1 m-0 leading-tight px-2">
            {step === 1
              ? "Ingrese su correo electrónico para recibir su código de acceso"
              : "Ingrese el código de 6 dígitos enviado a su correo"}
          </p>
        </div>

        {step === 1 ? (
          <form className="w-full" onSubmit={handleRequestCode}>
            <div className="flex flex-row items-center border border-[#F3F4F6] bg-[#FAFAFA] rounded-xl mb-6 h-14 px-4">
              <MdOutlineMail
                size={22}
                className="text-[#1D3B8B] mr-3 shrink-0"
              />
              <input
                type="email"
                placeholder="Correo electrónico"
                className="flex-1 bg-transparent border-none outline-none text-[15px] text-[#111827] placeholder-[#9CA3AF] h-full"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoCapitalize="none"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1D3B8B] rounded-xl h-14 flex flex-row justify-center items-center relative mb-5 border-none cursor-pointer opacity-100 disabled:opacity-70 transition-opacity"
            >
              <span className="font-bold text-white text-[16px]">
                {loading ? "Enviando..." : "Enviar Código"}
              </span>
              <MdArrowForward
                size={20}
                className="text-white absolute right-5"
              />
            </button>
          </form>
        ) : (
          <form className="w-full" onSubmit={handleVerifyCode}>
            <div className="flex flex-row items-center border border-[#F3F4F6] bg-[#FAFAFA] rounded-xl mb-4 h-14 px-4">
              <MdVpnKey size={22} className="text-[#1D3B8B] mr-3 shrink-0" />
              <input
                type="text"
                maxLength={6}
                placeholder="Código de 6 dígitos"
                className="flex-1 bg-transparent border-none outline-none text-[15px] text-[#111827] placeholder-[#9CA3AF] h-full tracking-widest text-center font-bold"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1D3B8B] rounded-xl h-14 flex flex-row justify-center items-center relative mb-4 border-none cursor-pointer opacity-100 disabled:opacity-70 transition-opacity"
            >
              <span className="font-bold text-white text-[16px]">
                {loading ? "Verificando..." : "Verificar Código"}
              </span>
              <MdArrowForward
                size={20}
                className="text-white absolute right-5"
              />
            </button>

            <button
              type="button"
              onClick={() => setStep(1)}
              className="w-full text-center text-[#6B7280] font-medium text-[13px] bg-transparent border-none cursor-pointer mb-5 hover:underline"
            >
              Cambiar correo electrónico
            </button>
          </form>
        )}

        <div className="flex justify-center border-t border-[#F3F4F6] pt-5">
          <Link
            to="/"
            className="flex items-center text-[#1D3B8B] font-bold text-[14px] no-underline hover:underline"
          >
            <MdArrowBack size={18} className="mr-1" />
            Volver al Inicio de Sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Recover;
